export default __webpack_public_path__ + "media/images/features/local_delivery/7order_logo-3be64f7b2b6ce8953a2b8f5911c5d174.png";